<template>
  <div style="width: 100%" v-if="!this.$parent.isLoadShow">
    <!-- navbar -->
    <b-navbar toggleable="lg" type="light" variant="" class="">
      <b-navbar-brand>
        <div style="display: flex; align-items: center;">
          <i class="rs-icon-default rs-icon-logo rs-icon-title-color"></i>
          <div style="color: #032313; padding-left: 13px;">儲值頁面</div>
        </div>
      </b-navbar-brand>
    </b-navbar>
    <!-- content -->
    <div class="rs-account-profile-content-sty">
      <div style="margin-bottom: 2rem;">
        <h5 style="color: #86918d">{{ userInfo.name }}，您好!</h5>
        <div v-if="userType === 'customer' && !hadTransferInfo">
          <h5 style="color: #bd7456">您還未匯款</h5>
        </div>
      </div>
      <!-- transfer info -->
      <div v-if="userType === 'customer' && hadTransferInfo">
        <!-- <h5> 目前資訊 </h5> -->
        <b-card-group>
          <b-row class="rs-account-transfercard-rowsty">
            <b-col>
              <b-card
                no-body
                class="rs-account-transfercard-sty"
              >
                <template #header>
                  <h6 class="mb-0">目前方案</h6>
                </template>
                <b-card-body class="rs-account-transfercard-bodysty" style="display: flex; align-items: center;">
                  <b-card-text>
                    <h5 style="color: #8ca19f">{{ transferInfo.planName }}</h5>
                    <!-- <hr> -->
                    <!-- <div class="row">
                      <div class="col-sm-3">
                        <b>待審核金額</b>
                      </div>
                      <div class="col-sm-9" style="color: red;"> {{ transferInfo.total }} </div>
                    </div> -->
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col>
              <b-card
                no-body
                class="rs-account-transfercard-sty"
                >
                <template #header>
                  <h6 class="mb-0">儲值金額</h6>
                </template>
                <b-card-body class="rs-account-transfercard-bodysty w-100" style="margin-top: 1rem">
                  <b-card-text>
                    <div class="row">
                      <div class="col-sm-3">
                        <b>待審核金額</b>
                      </div>
                      <div class="col-sm-9">
                        <span v-if="transferInfo.unconfirm_cash" class="rs-font-secgreen" style="color: red;"> {{ transferInfo.unconfirm_cash }}</span>
                        <span v-else class="rs-font-secgreen"> 0 </span>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-sm-3">
                        <b>儲值餘額</b>
                      </div>
                      <div class="col-sm-9">
                        <span class="rs-font-secgreen">{{ transferInfo.current }}</span>
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
            <div class="w-100"></div>
            <b-col>
              <b-card
                no-body
                class="rs-account-transfercard-sty"
                >
                <template #header>
                  <h6 class="mb-0">回饋金額</h6>
                </template>
                <b-card-body class="rs-account-transfercard-bodysty" style="display: flex; align-items: center;">
                  <b-card-text>
                    <h5 style="color: #893614">即將推出<br/>敬請期待  </h5>
                    <!-- <h5 class="rs-font-secgreen" v-if="transferInfo.freeCash >= 0">{{ transferInfo.freeCash }}</h5>
                    <h5 class="rs-font-red" v-else>{{ transferInfo.freeCash }}</h5> -->
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col>
              <b-card
                no-body
                class="rs-account-transfercard-sty"
                >
                <template #header>
                  <h6 class="mb-0">優惠</h6>
                </template>
                <b-card-body v-if="(transferBouns.disinfect && transferBouns.disinfect.length > 0) || transferBouns.service || transferBouns.specialService" class="rs-account-transfercard-bodysty" style="display: flex; align-items: center;">
                  <b-card-text>
                    <h5 style="color: #893614">更多福利<br/>敬請期待</h5>
                    <!-- <h6 v-for="(disinfect, index) in transferBouns.disinfect" :key="index">
                      <span class="rs-font-secgreen"> {{disinfect.gap}} </span>
                      <span>個月一次定期消毒服務( 剩餘</span>
                      <b class="rs-font-red">{{ disinfect.current }}</b>
                      <span>次 )</span>
                    </h6>
                    <h6 v-for="(service, index) in transferBouns.service" :key="index"> {{ service }} </h6>
                    <a v-if="transferBouns.specialService" @click="displayTransferBounsDetail">
                      ... 查看所有福利
                    </a> -->
                  </b-card-text>
                </b-card-body>
                <b-card-body v-else class="rs-account-transfercard-bodysty" style="display: flex; align-items: center;">
                  <b-card-text>
                    <h5 style="color: #8ca19f"> - </h5>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-card-group>
        <div v-if="transferInfo.unconfirm_cash" class="col-md-12">
          <b style="color: red;"> 金額紅字未審核通過的金額, 如果您已有匯款，請等待工作人員審核 </b>
        </div>
      </div>
      <div v-else>
        <div>
          <h5 style="color: #032313">選擇屬於您的儲值方案</h5>
        </div>
        <div class="rs-account-profile-content-sty">
          <div v-for="(plan, index) in planArray" :key="index">
            <b-card-group @click="selectPlan(index)">
              <b-card
                no-body
              >
                <template #header>
                  <h6 class="mb-0">{{ plan.name }}</h6>
                </template>
                <b-card-body>
                  <b-card-title v-if="plan.id !== 9"><h5 style="color: #86918d">儲值 {{ plan.cash }}</h5></b-card-title>
                  <b-card-sub-title v-if="plan.id !== 9 && plan.free_cash > 0"><h6 style="color: #a06f6c">額外折扣 {{ plan.free_cash }}</h6></b-card-sub-title>
                  <b-card-text v-if="plan.id === 9">
                    <b-input-group>
                      <b-form-input placeholder="輸入想儲值金額" type="number" v-model="planCash"></b-form-input>
                      <b-button
                        class="text-white"
                        variant="info"
                        style="background-color: #445e5b"
                        size="md"
                        @click="selectPlan(index, true)"
                        v-if="displayCashInputBtn"
                        >儲值
                      </b-button>
                    </b-input-group>
                  </b-card-text>
                  <b-card-text v-else>
                    <div v-if="plan.id === 5">
                      <span style="color: #86918d">差不多等同於</span>
                      <span class="rs-font-red">15</span>
                      <span style="color: #86918d">次服務</span>
                    </div>
                    <div v-if="plan.id === 6">
                      <div style="color: #86918d">
                        <span>差不多等同於</span>
                        <span class="rs-font-red">30</span>
                        <span>次服務</span>
                      </div>
                      <div style="color: #6d5049">
                        <span style="color: #bd7456">6</span>
                        <span> 個月一次定期消毒服務 (共</span>
                        <span style="color: #bd7456">2</span>
                        <span>次)</span>
                      </div>
                    </div>
                    <div v-if="plan.id === 7">
                      <div style="color: #86918d">
                        <span>差不多等同於</span>
                        <span class="rs-font-red">60</span>
                        <span>次服務</span>
                      </div>
                      <div style="color: #6d5049">
                        <span style="color: #bd7456">4</span>
                        <span> 個月一次定期消毒服務 (共</span>
                        <span style="color: #bd7456">3</span>
                        <span>次)</span>
                      </div>
                      <div style="color: #6d5049">
                        <span> 精油薰香/</span>
                        <span style="color: #bd7456">每次</span>
                      </div>
                    </div>
                    <div v-if="plan.id === 8">
                      <div style="color: #6d5049">
                        <span style="color: #bd7456">3</span>
                        <span> 個月一次定期消毒服務 (共</span>
                        <span style="color: #bd7456">4</span>
                        <span>次)</span>
                      </div>
                      <div style="color: #6d5049">
                        <span style="color: #bd7456"> 每次服務涵蓋: </span>
                        <p>精油薰香、空氣品質檢測、濕度檢測…等</p>
                      </div>
                      <div style="color: #6d5049">
                        <span> 限定執事以上等級人員前往</span>
                        <p style="color: #bd7456">通過內部多重考核，高服務品質認證</p>
                      </div>
                      <div class="rs-font-red">
                        <p>定期除塵螨，定期居家安全檢查，其他專屬客制化服務（會員護照）</p>
                      </div>
                      <div class="rs-font-red">
                        <p>未來新服務項目、保養項目（防水鍍膜、金屬保養、皮革保養）、活動優惠，皆優先體驗、安排。</p>
                      </div>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-card-group>
          </div>
        </div>
      </div>
      <!-- button -->
      <div style="margin-top: 25px">
        <b-button
            class="text-white"
            variant="info"
            style="background-color: #445e5b"
            size="lg"
            @click="goToSelectPlan"
            v-if="hadTransferInfo && !transferUnCheck"
            >前往儲值
        </b-button>
        <b-button
            class="text-white"
            variant="info"
            style="background-color: #445e5b"
            size="lg"
            @click="checkTransferCode"
            v-if="transferUnCheck"
            >未確認匯款
        </b-button>
        <b-button
            class="text-white"
            variant="info"
            size="lg"
            @click="openTranslateInfo"
            v-if="transferUnCheck"
            >匯款資訊
        </b-button>
        <div v-if="hadTransferInfo" style="float: right;margin-top: 10px;">
          <a @click="openTranslateRecords()" style="color: #7e8884;text-decoration:underline;">
            <span class=""><i class="rs-icon-default rs-icon-timeline"></i></span>
            <b>儲值紀錄</b>
          </a>
        </div>
      </div>
    </div>
    <b-modal id="rsSelectProfileTranPlan" ref="rsselectprofiletranplan-modal">
      <template>
        <div class="row" style="font-size: 20px">
          <div class="col-md-12">
              <h4>儲值方案確認</h4>
              <div>請確認以下方案資訊是否有誤</div>
          </div>
          <div class="col-sm-4">方案:</div>
          <div class="col-sm-8" style="color: #456361">{{ planSelectedName }}</div>
          <div class="col-sm-4">儲值金額:</div>
          <div class="col-sm-8" style="color: #456361">{{ planCash }}</div>
          <div class="col-sm-4" v-if="planFreeCash > 0"> 額外折扣 </div>
          <div class="col-sm-8" v-if="planFreeCash > 0" style="color: #445e5b">{{ planFreeCash }}</div>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="dark" @click="confirmPlanCheck()" style="width:100px;">
          確認
        </b-button>
        <b-button size="sm" variant="light" @click="cancel()" style="width:100px;">
          取消
        </b-button>
      </template>
    </b-modal>
    <b-modal id="rsProfileTranCheck" ref="rsprofiletrancheck-modal">
      <template>
        <div class="row">
          <div class="col-md-12">
            <h5>儲值資訊是否已確認無誤?</h5>
            <h5>點擊<span style="color: #AA7A72">確認</span>後將為您送出</h5>
          </div>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="dark" @click="confirmPlan()" style="width:100px;">
          確認
        </b-button>
        <b-button size="sm" variant="light" @click="cancel()" style="width:100px;">
          取消
        </b-button>
      </template>
    </b-modal>
    <b-modal id="rsProfileTranComplete" ref="rsprofiletrancomplete-modal">
      <template>
        <div class="row" style="font-size: 20Px">
          <div class="col-md-12">
            <h4>匯款資訊</h4>
            <div v-if="planSelectedName">
              <span>方案:</span>
              <span style="color: #456361">{{ planSelectedName }}</span>
            </div>
            <div v-if="planCash">
              <span>儲值金額:</span>
              <span style="color: #456361">{{ planCash }}</span>
            </div>
            <div v-if="planFreeCash > 0">
              <span>額外折扣:</span>
              <span style="color: #456361">{{ planFreeCash }}</span>
            </div>
            <hr>
            <div>請於時間內匯款至以下帳戶:</div>
            <div><b>{{ this.companyBankName }}</b><b style="color: #456361">{{ this.companyBankCode }}</b></div>
            <div style="color: #AA7A72" @click="copyCompanyAccount">{{ this.companyAccount }}</div>
            <b-button
              size="sm" variant="secondary"
              @click="copyCompanyAccount"
            >
              <b-icon icon="files" aria-hidden="true"></b-icon>
              複製帳戶
      </b-button>
          </div>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button v-if="planSelectedName" size="sm" variant="dark" @click="getTransferProfile('rsProfileTranComplete')" style="width:100px;">
          確認
        </b-button>
        <b-button v-else size="sm" variant="dark" @click="cancel()" style="width:100px;">
          確認
        </b-button>
      </template>
    </b-modal>
    <b-modal id="rsTransferRecords" ref="rstransferrecords-modal">
      <template>
        <div class="row">
          <div class="col-md-12" style="height: 100vh;display: flex;justify-content: center;align-items: center;" v-if="recordLoading">
            <b-spinner style="width: 10em; height: 10rem;" label="Large Spinner" type="grow"></b-spinner>
          </div>
          <div class="col-md-12" v-else>
              <div v-if="transferRecords.length > 0">
                <div class="lst-transfer-sty" v-for="(record, index) in transferRecords" :key="index">
                  <div class="list-transfer-id-sty">
                    <span class="transfer-id-sty"># {{ record.id }} </span>
                    <span class="list-transfer-date-sty" style="margin-left: 10px;">{{record.dsCreateDate}}</span>
                    <span class="list-transfer-time-sty">{{record.dsCreateTime }}</span>
                  </div>
                  <hr>
                  <div class="list-transfer-maincontent-sty">
                    <div>{{record.plan_name}}</div>
                    <div :class="`list-transfer-status-sty ${ record.statusClass }`">{{ record.status }}</div>
                    <div>儲值金額: {{record.cash}}</div>
                    <div>已匯款金額: {{record.total_transfer_cash}}</div>
                  </div>
                  <hr>
                </div>
              </div>
              <div v-else>
                <div class="row">
                </div>
              </div>
          </div>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="dark"  @click="cancel()" style="width:100px;">
          確認
        </b-button>
      </template>
    </b-modal>
    <b-modal id="rsTransferBonus" ref="rstransferbnus-modal">
      <template>
        <div class="row">
          <div class="col-md-12">
            <h6 v-if="transferBouns.disinfect">
              <span class="rs-font-secgreen"> {{transferBouns.disinfect.gap}} </span>
              <span>個月一次定期消毒服務( 剩餘</span>
              <b class="rs-font-red">{{ transferBouns.disinfect.current }}</b>
              <span>次 )</span>
            </h6>
          </div>
          <div class="col-md-12">
            <h6 v-for="(service, index) in transferBouns.service" :key="index"> {{ service }} </h6>
          </div>
          <div class="col-md-12" v-if="transferBouns.specialService.dust_mite">
            <h6>定期除塵螨</h6>
          </div>
          <div class="col-md-12" v-if="transferBouns.specialService.security_check">
            <h6>定期居家安全檢查</h6>
          </div>
          <div class="col-md-12" v-if="transferBouns.specialService.service_level">
            <h6>限定執事以上等級（通過內部多重考核，高服務品質認證）人員前往</h6>
          </div>
          <div class="col-md-12" v-if="transferBouns.specialService.priority">
            <h6>未來新服務項目、保養項目（防水鍍膜、金屬保養、皮革保養）、活動優惠，皆優先體驗、安排。</h6>
          </div>
          <div class="col-md-12">
            <h6 v-for="(service, index) in transferBouns.specialService.other" :key="index"> {{ service }} </h6>
          </div>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()" style="width:100px;">
          確認
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import fakeDataProfile from '@/components/customer/transfer/fakeData/userProfile.json'
import fakeDataRecord from '@/components/customer/transfer/fakeData/translateRecords.json'
export default {
  name: 'TransferProfile',
  props: {
    userType: String,
    userId: String
  },
  data () {
    return {
      userInfo: {
        name: '',
        url: ''
      },
      hadTransferInfo: false,
      transferInfo: {
        id: 9,
        planName: '-',
        freeCash: 0,
        costed: 0,
        lasted: 0,
        total: 0,
        current: 0
      },
      transferBouns: {
        disinfect: [],
        service: [],
        specialService: {}
      },
      // plan setting
      planArray: [],
      planSelectedName: null,
      planSelectedId: null,
      planCash: 0,
      planFreeCash: 0,
      displayCashInputBtn: false,
      usingFake: false,
      // record list
      recordLoading: false,
      transferRecords: [],
      transferRecordPage: 0,
      transferRecordTotalPage: 0,
      transferRecordTotalCounts: 0,
      // checkTransfer
      isNotifyLimit: false,
      transferUnCheck: false,
      unCheckTransferInfo: null,
      // defaut value
      companyBankName: '土地銀行',
      companyBankCode: '005',
      companyAccount: '144001022948'
    }
  },
  created () {
    this.$nextTick(() => {
      this.getUserProfile()
    })
  },
  methods: {
    getUserProfile () {
      const lineInfo = this.$store.getters.getProfile
      this.userInfo.name = lineInfo.displayName
      this.userInfo.url = lineInfo.pictureUrl
      console.log(lineInfo)
      console.log(fakeDataProfile)
      if (this.usingFake) {
        this.arrangeTransferData(fakeDataProfile.data)
        this.getTransferList()
      } else {
        this.getTransferProfile()
      }
    },
    getTransferProfile (modalStr) {
      const self = this
      const url = this.$apiDoc.customerUrl + this.userId + this.$apiDoc.apiGetTransferProfile
      this.$bvModal.show(modalStr)
      this.$parent.isLoadShow = true
      this.$api.get(url).then((resp) => {
        if (resp.result && resp.data) {
          self.arrangeTransferData(resp.data)
        }
        if (self.hadTransferInfo) {
          self.$parent.isLoadShow = false
        }
        self.getTransferList()
      }).catch((errorInfo) => {
        console.log(errorInfo)
        self.$parent.isLoadShow = false
      })
    },
    getPlan () {
      const self = this
      const url = this.$apiDoc.apiGetTransferPlan
      if (!this.$parent.isLoadShow) {
        this.$parent.isLoadShow = true
      }
      this.$api.get(url).then((resp) => {
        if (resp.result && resp.data) {
          self.planArray = self.arrangePlanList(resp.data)
        }
        self.$parent.isLoadShow = false
      }).catch((errorInfo) => {
        console.log(errorInfo)
        self.$parent.isLoadShow = false
      })
    },
    getTransferList (isModal) {
      const self = this
      const url = this.$apiDoc.customerUrl + this.userId + this.$apiDoc.apiGetTransferList
      if (this.usingFake) {
        this.transferRecords = this.arrangeTransferListData(fakeDataRecord.data)
        if (isModal) {
          this.recordLoading = false
        } else {
          this.$parent.isLoadShow = false
        }
      } else {
        if (isModal) {
          this.recordLoading = false
        }
        this.$api.get(url).then((resp) => {
          if (resp.result && resp.data) {
            self.transferRecords = self.arrangeTransferListData(resp.data)
          }
          if (isModal) {
            self.recordLoading = false
          } else {
            if (self.hadTransferInfo) {
              self.$parent.isLoadShow = false
            } else {
              self.getPlan()
            }
          }
        }).catch((errorInfo) => {
          console.log(errorInfo)
          if (isModal) {
            self.recordLoading = false
          } else {
            self.$parent.isLoadShow = false
          }
        })
      }
    },
    confirmPlan () {
      const self = this
      const options = {
        line_user_id: this.userId,
        top_up_plan_id: this.planSelectedId,
        cash: this.$toolDoc.turnToNumber(this.planCash),
        free_cash: this.$toolDoc.turnToNumber(this.planFreeCash),
        order_id: null
      }
      this.$parent.isLoadShow = true
      this.$api.post(this.$apiDoc.apiPostTransferPlan, options).then((resp) => {
        self.$bvModal.hide('rsProfileTranCheck')
        if (resp.result && resp.data) {
          self.$bvModal.show('rsProfileTranComplete')
        } else {
          self.$bvToast.toast('不好意思， 發生預期外的錯誤，可能是網路問題，麻煩稍後再嘗試', {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        }
        self.$parent.isLoadShow = false
      }).catch((errorInfo) => {
        console.log(errorInfo)
        self.$parent.isLoadShow = false
        self.$bvToast.toast('不好意思， 發生預期外的錯誤，可能是網路問題，麻煩稍後再嘗試', {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
      })
    },
    arrangeTransferData (data) {
      if (data) {
        this.transferInfo.id = data.plan_id ? data.plan_id : null
        this.transferInfo.planName = data.plan_name ? data.plan_name : '-'
        this.transferInfo.freeCash = data.free_cash ? data.free_cash : 0
        this.transferInfo.costed = data.costed ? data.costed : 0
        this.transferInfo.lasted = data.lasted ? data.lasted : 0
        this.transferInfo.current = data.current ? data.current : 0
        this.transferInfo.total = data.total ? data.total : 0
        this.transferInfo.unconfirm_cash = data.unconfirm_cash ? data.unconfirm_cash : 0
        this.transferUnCheck = (data.active !== null && data.active !== undefined) ? !data.active : false
        if (data.bouns) {
          this.transferBouns.disinfect = data.bouns.disinfect ? data.bouns.disinfect : {}
          this.transferBouns.service = data.bouns.service ? data.bouns.service : []
          this.transferBouns.specialService = data.bouns.special_service ? data.bouns.special_service : {}
        }
        if (this.transferInfo.id || this.transferInfo.current || this.transferInfo.total) {
          this.hadTransferInfo = true
        }
      }
    },
    arrangePlanList (array) {
      var finalArray = []
      var freePlanIndex = -1
      var freePlan
      if (array) {
        freePlanIndex = array.findIndex((item) => {
          return item.id === 9
        })
        if (freePlanIndex >= 0) {
          freePlan = array.splice(freePlanIndex, 1)
        }
        finalArray = array
        if (freePlan) {
          console.log(freePlan)
          finalArray = finalArray.concat(freePlan)
        }
      }
      return finalArray
    },
    arrangeTransferListData (data) {
      const self = this
      var array = data.top_up_trans_infos ? data.top_up_trans_infos : []
      var finalArray = []
      var isNeedTransfer = false
      this.unCheckTransferInfo = null
      this.transferRecordPage = 0
      this.transferRecordTotalPage = 0
      this.transferRecordTotalCounts = 0
      if (!this.hadTransferInfo) {
        this.transferUnCheck = false
      }
      if (array) {
        array.forEach((item) => {
          console.log('item', item)
          if (!self.hadTransferInfo) {
            self.hadTransferInfo = true
          }
          item.dsCreateDate = self.$toolDoc.getDateTimeValue(item.created_at, { type: 'date' })
          item.dsCreateTime = self.$toolDoc.getDateTimeValue(item.created_at, { type: 'time' })
          if (item.is_transfer_cash_enough) {
            item.dsTransferDate = self.$toolDoc.getDateTimeValue(item.transfer_at, { type: 'date' })
            item.dsTransferTime = self.$toolDoc.getDateTimeValue(item.transfer_at, { type: 'time' })
          } else {
            isNeedTransfer = true
            self.transferUnCheck = true
            self.unCheckTransferInfo = item
          }
          if (!self.isNotifyLimit && item.is_notify_limit) {
            self.isNotifyLimit = item.is_notify_limit
          }
          if (isNeedTransfer) {
            item.statusClass = 'status-warn'
          } else {
            if (item.status === '審核中') {
              item.statusClass = 'status-info'
            } else {
              item.statusClass = 'status-sucess'
            }
          }
          finalArray.push(item)
        })
        finalArray = array
        this.transferRecordPage = data.page
        this.transferRecordTotalPage = data.total_page
        this.transferRecordTotalCounts = data.total_count
      }
      console.log('B', this.transferUnCheck)
      return finalArray
    },
    displayTransferBounsDetail () {
      this.$bvModal.show('rsTransferBonus')
    },
    goToSelectPlan () {
      const pt = '/' + this.$props.userType + '/transfer/plan'
      this.$router.push({ path: pt, replace: true })
    },
    confirmPlanCheck () {
      this.$bvModal.show('rsProfileTranCheck')
    },
    selectPlan (index, fromKey) {
      const selected = this.planArray[index]
      if (selected.id !== 9 || (this.displayCashInputBtn && selected.id && fromKey)) {
        if (selected.id === 9 && this.planCash < 2000) {
          this.$bvToast.toast('儲值金額至少需要2000元', {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        } else {
          this.planSelectedId = selected.id
          this.planSelectedName = selected.name
          if (selected.id === 9) {
            this.planFreeCash = 0
          } else {
            this.planCash = selected.cash
            this.planFreeCash = selected.free_cash
          }
          this.displayCashInputBtn = false
          this.$bvModal.show('rsSelectProfileTranPlan')
        }
      } else {
        this.displayCashInputBtn = true
      }
    },
    checkTransferCode () {
      const pt = '/' + this.$props.userType + '/transfer/transfercode'
      this.$router.push({ path: pt, replace: true })
    },
    openTranslateRecords () {
      this.$bvModal.show('rsTransferRecords')
    },
    openTranslateInfo () {
      this.$bvModal.show('rsProfileTranComplete')
    },
    copyCompanyAccount () {
      const self = this
      navigator.clipboard.writeText(this.companyAccount).then(() => {
        self.$bvToast.toast('成功複製帳號', {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'success',
          solid: true
        })
      })
    }
  }
}
</script>
